<template>
    <div class="flex justify-center text-sm text-gray-600">
      <label :for="'file-upload-' + ukey" class="cursor-pointer w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:ml-3 sm:w-auto sm:text-sm">
        <span>Upload a File</span>
        <input :id="'file-upload-' + ukey" :name="'file-upload-' + ukey" :ref="'file-' + ukey" type="file" class="sr-only" @change="uploadFile" :key="ukey">
      </label>
    </div>
</template>

<script>
export default {
    props: {
        endpoint: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        ukey: {
            type: String
        },
        supportedtypes: {
            type: String,
            default: "PDF, DOC, DOCX, PNG, JPG"
        }
    },
    data: function () {
        return {
            file: null
        }
    },
    methods: {
        uploadFile() {
            this.file = this.$refs['file-' + this.ukey].files[0];
            this.submitFile();
        },
        submitFile() {
            const formData = new FormData();

            formData.append('file', this.file);
            formData.append('type', this.type);

            const headers = { 'Content-Type': 'multipart/form-data' };

            window.axios.post(this.endpoint, formData, { headers })
            .then((res) => {
                location.reload();
            });
          }
    }
}
</script>
